module.exports = __webpack_public_path__ + "img/Audio.58a546fa.svg";